export default "__VITE_ASSET__CwoUtj5b__"